import React, { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  Typography,
  TextField,
  InputAdornment,
  Stack,
  Card,
  Avatar,
  Divider,
} from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';

import { request } from '../../../Utils/request';
import { useSelector } from 'react-redux';

interface BookingsTabProps {
  onTripClick: (trip: any) => void;
}

const BookingsTab: React.FC<BookingsTabProps> = ({ onTripClick }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [trips, setTrips] = useState<any[]>([]);
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);

  useEffect(() => {
    const fetchTrips = async () => {
      let endpoint = '/bookings/created';
      if (selectedDate) {
        endpoint += `?date=${selectedDate}`;
      }
      const res = await request<{ data: any }>(endpoint, {
        method: 'GET',
        authorization: true,
      });
      setTrips(res?.data);
    }
    if (isLoggedIn)
      fetchTrips();
  }, [selectedDate, isLoggedIn]);



  return (
    <>

      <>
        <TextField
          fullWidth
          type="date"
          label="Select Date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          sx={{ mb: 3 }}
          InputLabelProps={{ shrink: true }}
        />
      </>
      <Stack spacing={2} sx={{marginBottom:'100px'}}>
        {trips.map((trip) => (
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: 1,
              mb: 2,
              overflow: 'hidden',
              position: 'relative',
              cursor: 'pointer',
              '&:hover': {
                boxShadow: 2,
              },
            }}
            onClick={() => onTripClick(trip)}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
              <Avatar
                src={trip.files?.[0]?.fileURL}
                sx={{ width: 60, height: 60, borderRadius: 2, mr: 2 }}
                variant="rounded"
              />
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
                  {trip.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Location: {typeof trip.location === 'object' ? trip.location?.name : trip.location}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '1px',
                  backgroundColor: '#BAA89D',
                  alignSelf: 'stretch',
                  mx: 2,
                }}
              />
              <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                <Typography variant="h4" fontWeight="bold" color="#008387">
                  {trip?.upcomingBookingCount || trip?.totalPurchases || 0}
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#008387', fontWeight: 500 }}>
                  {trip.type === "trip"? "Bookings" : "Purchase"}
                </Typography>
              </Box>
            </Box>
            {trip.type && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bgcolor: '#FFE0B2',
                  color: '#8B4513',
                  borderRadius: '0 12px 0 16px',
                  px: 2,
                  py: 0.5,
                  fontSize: '12px',
                  fontWeight: 500,
                  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                }}
              >
                {trip.type ? `${trip.type.charAt(0).toUpperCase()}${trip.type.slice(1)}` : ''}
              </Box>
            )}
          </Card>
        ))}
      </Stack>
      {trips.length === 0 &&
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            No Bookings found
          </Typography>
        </Box>
      }
    </>
  );
};

export default BookingsTab;
